export default __webpack_public_path__ + "static/media/title_logo.13e6a7e3.svg";